import React from "react";
import AccountingPlaceholder from "./AccountingPlaceholder";

const OtherDocument: React.FC = () => (
  <AccountingPlaceholder title="Chứng từ khác" />
);

export default OtherDocument;
